import currency from 'currency.js'
import { currencyFormatter } from 'utils/helpers'

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toData = data => {
  data?.sales.push({
    salesPerson: 'GRAND TOTAL',
    targetRevenue: data.totalTargetRevenue,
    soldYTD: data.totalSoldYtd,
    percentToTargetRevenue: data.totalPercentToTargetRevenue,
    targetProfit: data.totalTargetProfit,
    profitYTD: data.totalProfitYTD,
    percentToTargetProfit: data.totalPercentToTargetProfit,
    remainingToQuota: data.totalRemainingToQuota,
    forecast: data.totalForecast,
    soldAndForecast: data.totalSoldAndForecast,
    remainingToQuotaWithForecast: data.totalRemainingToQuotaWithForecast
  })
  return {
    rtqBarSales: data.sales.map(item => {
      return {
        salesPerson: item.salesPerson,
        'Sold YTD': item.soldYTD,
        Forecast: item.forecast,
        'Remaining to Quota with Forecast': item.remainingToQuotaWithForecast
      }
    }),
    ytdBarSales: data.sales.map(item => {
      return {
        salesPerson: item.salesPerson,
        Profit: item.profitYTD,
        'Revenue - Profit': currency(item.soldYTD).subtract(item.profitYTD).value
      }
    }),
    rtqPieSales: data.sales.map(item => {
      return [
        {
          id: 'Sold YTD',
          label: 'Sold YTD',
          value: item.soldYTD,
          color: '#92D050'
        },
        {
          id: 'Forecast',
          label: 'Forecast',
          value: item.forecast,
          color: '#0070C0'
        },
        {
          id: 'Remaining to Quota with Forecast',
          label: 'Remaining to Quota with Forecast',
          value: item.remainingToQuotaWithForecast,
          color: '#A5A5A5'
        }
      ]
    }),
    ytdPieSales: data.sales.map(item => {
      return [
        {
          id: 'Profit',
          label: 'Profit',
          value: item.profitYTD,
          color: '#92D050'
        },
        {
          id: 'Revenue - Profit',
          label: 'Revenue - Profit',
          value: currency(item.soldYTD).subtract(item.profitYTD).value,
          color: '#ED7D31'
        }
      ]
    }),
    sales: data.sales.map(item => {
      let remainingToQuotaChart = 'pie'
      let soldYtdChart = 'pie'

      ;[item.soldYTD, item.forecast, item.remainingToQuotaWithForecast].some(i => {
        if (i < 0) {
          remainingToQuotaChart = 'bar'
          return true
        }
        return false
      })
      ;[item.profitYTD, currency(item.soldYTD).subtract(item.profitYTD).value].some(i => {
        if (i < 0) {
          soldYtdChart = 'bar'
          return true
        }
        return false
      })
      return {
        remainingToQuotaChart,
        soldYtdChart,
        salesPerson: item.salesPerson,
        targetRevenue: currencyFormatter({ value: item.targetRevenue }),
        soldYTD: currencyFormatter({ value: item.soldYTD }),
        percentToTargetRevenue: item.percentToTargetRevenue + '%',
        targetProfit: currencyFormatter({ value: item.targetProfit }),
        profitYTD: currencyFormatter({ value: item.profitYTD }),
        percentToTargetProfit: item.percentToTargetProfit + '%',
        remainingToQuota: currencyFormatter({ value: item.remainingToQuota }),
        forecast: currencyFormatter({ value: item.forecast }),
        soldAndForecast: currencyFormatter({ value: item.soldAndForecast }),
        remainingToQuotaWithForecast: currencyFormatter({
          value: item.remainingToQuotaWithForecast
        })
      }
    }),
    totalTargetRevenue: currencyFormatter({ value: data.totalTargetRevenue }),
    totalSoldYtd: currencyFormatter({ value: data.totalSoldYtd }),
    totalPercentToTargetRevenue: data.totalPercentToTargetRevenue + '%',
    totalTargetProfit: currencyFormatter({ value: data.totalTargetProfit }),
    totalProfitYTD: currencyFormatter({ value: data.totalProfitYTD }),
    totalPercentToTargetProfit: data.totalPercentToTargetProfit + '%',
    totalRemainingToQuota: currencyFormatter({ value: data.totalRemainingToQuota }),
    totalForecast: currencyFormatter({ value: data.totalForecast }),
    totalSoldAndForecast: currencyFormatter({ value: data.totalSoldAndForecast }),
    totalRemainingToQuotaWithForecast: currencyFormatter({
      value: data.totalRemainingToQuotaWithForecast
    })
  }
}

export const getColors = bar => {
  const colors = {
    'Sold YTD': '#92D050',
    Forecast: '#0070C0',
    'Remaining to Quota with Forecast': '#A5A5A5',
    Profit: '#92D050',
    'Revenue - Profit': '#ED7D31'
  }
  return colors[bar.id]
}

export const toYears = years => {
  return years.map(year => ({
    value: year,
    label: year
  }))
}
